import { useCallback, useEffect, useState } from "react";
import { viewAccountSummaryApi } from "../services/accountSummaryService";

export const useFetchAccountSummary = () => {
  const [isloading, setLoading] = useState(true);
  const [accountSummary, setAccountSummary] = useState([]);

  const fetchSummary = useCallback(async () => {
    setLoading(true);
    try {
      const response = await viewAccountSummaryApi();
      //   console.log(response.get_company_user_overview);
      setAccountSummary(response.get_company_user_overview);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchSummary();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchSummary]);

  return {
    isloading,
    accountSummary,
  };
};
